<div class="custom-chip" [ngClass]="bgColorClass">
    <img [ngStyle]=" imgSize ? { 'width': imgSize}: { 'width': '14px' }" src="{{svgUrl}}" alt="{{alt}} count" />
    <p style="font-size: 13px;">
        {{label}}
    </p>
    
</div>
